import tmhRequest from '@/config/tmhRequest'

export default {

    searchStoreOpenPlatform: function (data) {
        return tmhRequest({
            url: '/system/tmh/storeopenplatform/searchstoreopenplatform',
            method: 'post',
            params: data,
        })
    },

    searchListStoreOpenPlatform: function (data) {
        return tmhRequest({
            url: '/system/tmh/storeopenplatform/searchliststoreopenplatform',
            method: 'post',
            data: data,
        })
    },

    addStoreOpenPlatform: function (data) {
        return tmhRequest({
            url: '/system/tmh/storeopenplatform/addstoreopenplatform',
            method: 'post',
            params: data,
        })
    },
    editStoreOpenPlatform: function (data) {
        return tmhRequest({
            url: '/system/tmh/storeopenplatform/editstoreopenplatform',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/system/storeopenplatform.js